module.exports = __webpack_public_path__ + "static/img/advantage4.0d7fd33b.png";